export const isObject = (value: any) =>
  typeof value === 'object' && value !== null
